import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  background: linear-gradient(rgb(63, 98, 174) 0%, rgb(231, 228, 213) 35%);
`;
